/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getRangesForGroups = function getRangesForGroups(_ref) {
  var data = _ref.data,
    initialOffset = _ref.initialOffset,
    rowHeightManager = _ref.rowHeightManager,
    initialScrollTop = _ref.initialScrollTop;
  var keyPath;
  var depth = 0;
  var value = '';
  var ranges = data.map(function (row, i) {
    if (!row) {
      return;
    }
    var rowHeight = rowHeightManager.getRowHeight(i);
    var top = rowHeightManager.getRowOffset(i);
    var offset = top + initialOffset - (initialScrollTop || 0);
    var bottom = offset + rowHeight;
    if (row.__group) {
      keyPath = row.keyPath;
      depth = row.depth;
      value = row.value;
    }
    var result = {
      group: row.__group || false,
      keyPath: keyPath,
      leaf: row.leaf || false,
      value: value,
      depth: depth,
      top: offset,
      bottom: bottom,
      height: rowHeight,
      index: i
    };
    return result;
  });
  return ranges;
};
var _default = getRangesForGroups;
exports.default = _default;